import React, { useState, useEffect } from 'react';

const LoadingScreen = () => {
  const [show, setShow] = useState(true);
  const [fade, setFade] = useState(false);

  useEffect(() => {
    // Check if already shown this session
    if (sessionStorage.getItem('loaded')) {
      setShow(false);
      return;
    }
    const fadeTimer = setTimeout(() => setFade(true), 1200);
    const hideTimer = setTimeout(() => {
      setShow(false);
      sessionStorage.setItem('loaded', '1');
    }, 1600);
    return () => { clearTimeout(fadeTimer); clearTimeout(hideTimer); };
  }, []);

  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] bg-gray-950 flex items-center justify-center transition-opacity duration-400 ${fade ? 'opacity-0' : 'opacity-100'}`}
      style={{ pointerEvents: fade ? 'none' : 'all' }}
    >
      <div className="text-center">
        <img
          src="/logo.jpg"
          alt="Design Vision"
          className="w-20 h-20 rounded-2xl mx-auto mb-4 shadow-2xl"
          style={{ animation: 'logoReveal 0.8s ease-out forwards' }}
        />
        <p
          className="font-display text-xl font-bold text-white"
          style={{ animation: 'logoReveal 0.8s ease-out 0.3s forwards', opacity: 0 }}
        >
          Design<span style={{ color: '#d987ff' }}>Vision</span>
        </p>
      </div>
      <style>{`
        @keyframes logoReveal {
          from { opacity: 0; transform: scale(0.8) translateY(10px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default LoadingScreen;
